export default function getTimestamp(): number {
  return (new Date()).getTime();
}



// WEBPACK FOOTER //
// ./src/shared/helpers/getTimestamp.ts